import bookingService from 'components/Booking-new/services/BookingService';

const checkDuplicateBookingAndPushGTM = async (userDetails, serviceCode) => {
  const { email } = userDetails;
  const body = { email };
  const params = { serviceCode };

  const { data: bookingData, error } = await bookingService.checkDuplicateBooking(body, params);

  return {
    bookingData,
    error,
  };
};

export default checkDuplicateBookingAndPushGTM;
